import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { GpuToastService, GpuToastType } from '@geneplanet/ngx-ui';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subject, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class NoInternetInterceptor implements HttpInterceptor {
  private toastrService = inject(GpuToastService);
  private translateService = inject(TranslateService);

  private buttonClicked$ = new Subject<void>();

  constructor() {
    this.buttonClicked$.subscribe(() => {
      if (window.navigator.onLine) {
        window.location.reload();
      } else {
        this.showMessage();
      }
    });
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: unknown) => {
        // navigator.onLine can only ever prove we are offline, never that we
        // are online, and the Android WebView reports false spuriously during
        // cold start and network changes. Trust it only once a request has
        // actually failed to reach the server.
        if (this.isOffline(error)) {
          this.showMessage();
        }
        return throwError(() => error);
      })
    );
  }

  private isOffline(error: unknown): boolean {
    return (
      error instanceof HttpErrorResponse &&
      error.status === 0 &&
      !window.navigator.onLine
    );
  }

  private showMessage(): void {
    const text = this.translateService.instant(
      'FAILURE.NO_INTERNET_TOAST.DESCRIPTION'
    );
    const buttonText = this.translateService.instant('FAILURE.RETRY');

    this.toastrService.show({ text, buttonText }, GpuToastType.Error, {
      disableTimeout: true,
      buttonClicked$: this.buttonClicked$,
    });
  }
}
